export const Product_Request = "product/request";
export const Product_Error = "product/error";
export const Get_Product_Success = "get/product/success";